import { z } from 'zod'
import { enumerated } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

const incentiveType = enumerated({
  protectedFountain: 'Fonte protegida',
  caxambuFountain: 'Fonte caxambu',
})
export const incentiveTypeOptions = (incentiveType.getMeta()?.keysAndLabels ?? {}) as Record<
  string,
  string
>

const waterSourceApplicationValue = z
  .union([z.number(), z.string()])
  .transform(value => Number(value))
  .refine(value => Number.isFinite(value), 'Valor numérico inválido')

export const waterSourceApplicationObject = z.object({
  id: z.string().uuid(),
  citizenId: z.string().uuid(),
  incentiveType: incentiveType,
  value: waterSourceApplicationValue.nullish(),
  bankHolderName: z.string().max(255).nullish(),
  bankHolderDocument: z.string().max(64).nullish(),
  bankName: z.string().max(128).nullish(),
  bankBranch: z.string().max(64).nullish(),
  bankAccount: z.string().max(64).nullish(),
  observation: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type WaterSourceApplicationType = z.infer<typeof waterSourceApplicationObject>

export const propertyMap = {
  id: sql`water_source_application.id`,
  citizenId: sql`water_source_application.citizen_id`,
  incentiveType: sql`water_source_application.incentive_type`,
  value: sql`water_source_application.value`,
  bankHolderName: sql`water_source_application.bank_holder_name`,
  bankHolderDocument: sql`water_source_application.bank_holder_document`,
  bankName: sql`water_source_application.bank_name`,
  bankBranch: sql`water_source_application.bank_branch`,
  bankAccount: sql`water_source_application.bank_account`,
  observation: sql`water_source_application.observation`,
  createdAt: sql`water_source_application.created_at`,
  updatedAt: sql`water_source_application.updated_at`,
  deletedAt: sql`water_source_application.deleted_at`,
}
